import { Hammer, Users, Rocket, Sparkles } from "lucide-react";

// Single source of truth for the $ROBBED roadmap — used by /roadmap and the homepage preview.
export const ROADMAP_PHASES = [
  {
    n: 1, title: "Build The Community", status: "COMPLETED", Icon: Hammer,
    items: ["Meme Generator", "Community Wall", "Leaderboard / ROB Levels", "Character System", "Meme of the Moment", "X Sharing"],
  },
  {
    n: 2, title: "Grow The Community", status: "PLANNED", Icon: Users,
    items: ["Community challenges", "More characters and props", "More meme tools", "Social campaigns", "Community rewards"],
  },
  {
    n: 3, title: "Token Launch Preparation", status: "PLANNED", Icon: Hammer,
    items: [
      { label: "Finalize token architecture" },
      { label: "Solana + Robinhood Chain" },
      { label: "Finalize public/community distribution", to: "/tokenomics" },
      { label: "Liquidity planning", to: "/tokenomics" },
      { label: "Team vesting", to: "/tokenomics" },
      { label: "Security / contract review" },
    ],
  },
  {
    n: 4, title: "$ROBBED Launch", status: "PLANNED", Icon: Rocket,
    items: ["Token deployment", "Public/community distribution", "Liquidity deployment", "Publish verified contract addresses", "Launch communications"],
  },
  {
    n: 5, title: "Community-Driven Growth", status: "PLANNED", Icon: Sparkles,
    items: ["Community rewards and airdrops", "Partnerships", "Ecosystem expansion", "Future community features"],
  },
];
